/**
 * Nigerian naira.
 */
export var NGN = {
  code: 'NGN',
  base: 10,
  exponent: 2
};